import React from 'react'

import { PaymentAPI, PaymentProvider, PaymentResponse, ProcessPaymentOptions } from '../typings/Payment'

import Routes from './routes'
import { OnAction, RegisterActionHandler } from './useActionHandlers'

interface StepValidation {
  isProductSelectionValid: boolean
  setIsProductSelectionValid: (valid: boolean) => void
  isRequiredInformationValid: boolean
  setIsRequiredInformationValid: (valid: boolean) => void
  isPoliciesValid: boolean
  setIsPoliciesValid: (valid: boolean) => void
  isAddOnsValid: boolean
  setIsAddOnsValid: (valid: boolean) => void
  setIsMultiAnswerPatronQuestionValid: (valid: boolean) => void
  isPaymentValid: boolean
  setIsPaymentValid: (valid: boolean) => void
  isCurrentStepValid: (step: Routes) => boolean
}

export type ProcessPaymentFunction = (
  paymentProvider: PaymentProvider,
  paymentAPI: PaymentAPI,
  options: ProcessPaymentOptions,
) => Promise<PaymentResponse>

interface PaymentProcessing {
  isPaymentProcessing: boolean
  setIsPaymentProcessing: (isProcessing: boolean) => void
  processPayment?: () => ReturnType<ProcessPaymentFunction>
  setProcessPayment: (fn: () => ProcessPaymentFunction) => void
}

interface VoucherData {
  registerVoucherRemovalHandler: RegisterActionHandler<{ code: string }>
  onVoucherRemoval: OnAction<{ code: string }>
}

interface GlobalExpectedErrors {
  errors?: Record<string, string>
  setError: (key: string, error: string) => void
  getError: (key: string) => string | null
  clearError: (key: string) => void
  getErrors: () => Array<string>
  clearErrors: () => void
}

export interface ContextData extends StepValidation, PaymentProcessing, VoucherData, GlobalExpectedErrors {
  steps: Array<string>
  setSteps: (steps: Array<string>) => void
  recalculateSteps: () => Promise<void>
  getNextStep: () => string
  getPreviousStep: () => string
  hasMutationNetworkError?: boolean
  setHasMutationNetworkError: (hasMutationNetworkError: boolean) => void
  isSummaryLoading: boolean
  setIsSummaryLoading: (isLoading: boolean) => void
  isVenueBrandingEnabled: boolean
}

const Context = React.createContext<undefined | ContextData>(undefined)

export default Context
